import { LayoutHelperState } from "../types/LayoutHelperState";
import { IPayloadWrapper } from "../types/PayloadWrapper";

export const SET_INFOBAR_HEIGHT = "automatpacken/application/SET_INFOBAR_HEIGHT";
export const SET_RX_WARNING_LIST_HEIGHT = "automatpacken/application/RX_WARNING_LIST_HEIGHT_SET";
export const SET_RX_SINGLE_LIST_BUTTON_HEIGHT = "automatpacken/application/SET_RX_SINGLE_LIST_BUTTON_HEIGHT";

/**
 * -------------------------------------
 * Action Creator definitions
 * -------------------------------------
 * */
export const setInfoBarHeight = (payload: IPayloadWrapper<number>) =>{
  return {
    type: SET_INFOBAR_HEIGHT,
    payload,
  };
};

export const setRxWarningHeight = (payload: IPayloadWrapper<number>) =>{
  return {
    type: SET_RX_WARNING_LIST_HEIGHT,
    payload,
  };
};

export const setRxSingleListButtonHeight = (payload: IPayloadWrapper<number>) =>{
  return {
    type: SET_RX_SINGLE_LIST_BUTTON_HEIGHT,
    payload,
  };
};

const initialLayoutHelperState: LayoutHelperState = {
  height: 10,
  rxSingleItemListButtonHeight: 0,
  rxWarningHeight: 0
};

/**
 * -------------------------------------
 * Reducer definition
 * -------------------------------------
 * */
const layoutHelperReducer = (state = initialLayoutHelperState, action: any) => {
  switch (action.type) {
    case SET_INFOBAR_HEIGHT:
      return { ...state, height: action.payload.value };
    case SET_RX_WARNING_LIST_HEIGHT:
      return { ...state, rxWarningHeight: action.payload.value };
    case SET_RX_SINGLE_LIST_BUTTON_HEIGHT:
      return { ...state, rxSingleItemListButtonHeight: action.payload.value };
    default:
      return state;
  }
};

/**
 * -------------------------------------
 * Public interface
 * -------------------------------------
 * */
export default layoutHelperReducer;
